import { rankList } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

const trendIcon: Record<string, string> = { up: "ri-arrow-up-line text-primary-600", down: "ri-arrow-down-line text-accent-600", flat: "ri-loader-3-line text-secondary-600" };

export default function RankSection() {
  return (
    <section id="rank" className="scroll-mt-24 bg-background-100/60">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <SectionHeading eyebrow="实时热度榜" title="今日热议 · 热度排行 TOP 10" sub="聚合全网讨论量、阅读增长与时间衰减，综合计算热度指数，每 5 分钟实时刷新。" />
          <span className="inline-flex shrink-0 items-center gap-2 rounded-full border border-background-300 bg-background-50 px-3 py-1.5 text-xs font-bold text-foreground-600 whitespace-nowrap">
            <i className="ri-time-line text-accent-600"></i>
            更新于 14:32 · 共 128 个话题在榜
          </span>
        </div>

        <div className="mt-8 grid gap-8 lg:grid-cols-12">
          <div className="lg:col-span-8">
            <div className="overflow-hidden rounded-2xl border border-background-200 bg-background-50">
              {rankList.map((item, i) => {
                const highlight = i < 3;
                const numColor = ["bg-primary-500", "bg-accent-500", "bg-secondary-500"][i] ?? "bg-background-200";
                const numText = highlight ? "text-background-50" : "text-foreground-700";
                return (
                  <div
                    key={item.rank}
                    className={`group flex items-start gap-4 px-4 py-4 transition-colors hover:bg-background-100/70 md:px-6 ${i !== rankList.length - 1 ? "border-b border-background-200/70" : ""}`}
                  >
                    <span className={`mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg font-heading text-base font-bold ${numColor} ${numText}`}>
                      {item.rank}
                    </span>
                    <div className="min-w-0 flex-1">
                      <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                        <h3 className={`text-[15px] font-semibold text-foreground-950 md:text-base ${highlight ? "text-primary-700" : ""}`}>
                          {item.title}
                        </h3>
                        <span className="inline-flex shrink-0 items-center rounded-md bg-accent-100 px-2 py-0.5 text-xs font-bold text-accent-800">
                          {item.tag}
                        </span>
                      </div>
                      <p className="mt-1 hidden text-sm text-foreground-600 sm:block">{item.desc}</p>
                      <div className="mt-2 flex items-center gap-3">
                        <div className="h-1.5 w-full max-w-[260px] overflow-hidden rounded-full bg-background-200">
                          <div className={`h-full rounded-full ${highlight ? "bg-primary-500" : "bg-accent-500/70"}`} style={{ width: `${item.heat}%` }}></div>
                        </div>
                        <span className="text-xs font-bold text-foreground-800 whitespace-nowrap">{item.heat}</span>
                        <i className={`text-sm ${trendIcon[item.trend]}`}></i>
                      </div>
                    </div>
                    <button
                      type="button"
                      onClick={() => document.getElementById("buzz")?.scrollIntoView({ behavior: "smooth" })}
                      className="hidden shrink-0 items-center gap-1 rounded-md border border-background-200 px-2.5 py-1.5 text-xs text-foreground-600 whitespace-nowrap transition-colors group-hover:border-primary-300 group-hover:bg-primary-50 group-hover:text-primary-700 md:flex"
                    >
                      围观
                      <i className="ri-arrow-right-line"></i>
                    </button>
                  </div>
                );
              })}
            </div>
          </div>

          {/* 侧栏 */}
          <aside className="lg:col-span-4">
            <div className="rounded-2xl border border-background-200 bg-background-50 p-5 md:p-6">
              <h4 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
                <i className="ri-cpu-line text-primary-600"></i>
                热度指数怎么算
              </h4>
              <ul className="mt-4 space-y-3 text-sm text-foreground-700">
                <li className="flex gap-2.5"><i className="ri-checkbox-circle-line mt-0.5 text-accent-600"></i>讨论量：全网相关帖文的增量与总量</li>
                <li className="flex gap-2.5"><i className="ri-checkbox-circle-line mt-0.5 text-accent-600"></i>阅读增长：话题内容被浏览的实时速度</li>
                <li className="flex gap-2.5"><i className="ri-checkbox-circle-line mt-0.5 text-accent-600"></i>时间衰减：热度随时间自然回落的修正</li>
              </ul>
              <div className="mt-5 rounded-xl bg-secondary-100/70 p-4">
                <p className="text-sm font-bold text-secondary-900">互动小提示</p>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-700">
                  排名仅反映公开讨论热度，不代表事件本身的对错。理性围观，把结论交给时间与官方核实。
                </p>
              </div>
              <button
                type="button"
                onClick={() => document.getElementById("buzz")?.scrollIntoView({ behavior: "smooth" })}
                className="mt-5 flex w-full items-center justify-center gap-2 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-bold whitespace-nowrap text-background-50 transition-colors hover:bg-primary-600"
              >
                马上吃瓜，看大瓜现场
                <i className="ri-arrow-right-down-line"></i>
              </button>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}